var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconThickCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.00003C17 1.5 17.1 2.81673 16.5 3.4999L7.73584 13.5374C7.13941 14.2165 6.10705 14.2878 5.42294 13.6971L0.570457 9.50749C-0.117763 8.91328 -0.193977 7.87367 0.40023 7.18545C0.994436 6.49723 2.03405 6.42101 2.72227 7.01522L6.33912 10.138L13.5 1.9999C14.1 1.31674 15 0.500009 16 1.00003Z",
    fill: "#67AC5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconThickCheck);
export default __webpack_public_path__ + "static/media/streamline-icon-thick-check.a5d4ae35.svg";
export { ForwardRef as ReactComponent };